/**
 * Portfolio component
 *
 * Highlights some of  your creations. These can be designs, websites,
 * open source contributions, articles you've written and more.
 *
 * This is a great area for you to to continually add to and refine
 * as you continue to learn and create.
 */

import React from "react";

/**
 * Desk image
 *
 * Below is a sample desk image. Feel free to update this to an image of your choice,
 * updating below imageAltText to string that represents what you see in that image.
 *
 * Need an image? Check out https://unsplash.com to download a photo you
 * freely use on your site.
 */
import image from "../images/design-desk.jpeg";

const imageAltText = "desktop with books and laptop";

/**
 * Project list
 *
 * An array of objects that will be used to display for your project
 * links section. Below is a sample, update to reflect links you'd like to highlight.
 */
const projectList = [
  {
    title: "Forest Fire Detection and Alarm System",
    description:
      "Collaborated to develop a prototype of a forest fire early detection and alarm system utilizing satellite imagery and ground-based sensors.",
    url: "https://www.youtube.com/watch?v=VVQisS6v7VI",
  },
  {
    title: "Enhancing Agricultural Support for Small Scale Farmers in Kenya.",
    description:
      "This paper presents a mini weather station device as a data collector for a machine learning model, aiming to support the Kenyan agricultural sector through small-scale farmers",
    url: "https://edas.info/showPaper.php?m=1570955175",
  },
  {
    title: "MedicMavs Nutrition App",
    description:
      "Collaborated to develop an app to help people in Kenya learn about nutrition and make healthier eating choices based on their health conditions and location.",
    url: "https://devpost.com/software/inutri-app",
  },
  {
    title: "Mini Weather Station using GPRS and LoRa - iLabAfrica",
    description:
      "Colaborated to develop a compact weather monitoring station to address the issues encountered by small-scale farmers in Kenya.",
    url: "https://dpm-platform.web.app/",
  },
];

const Portfolio = () => {
  return (
    <section className="padding" id="portfolio">
      <h2 style={{ textAlign: "center" }}>Portfolio</h2>
      <div style={{ display: "flex", flexDirection: "row", paddingTop: "3rem" }}>
        <div style={{ maxWidth: "40%", alignSelf: "center" }}>
          <img
            src={image}
            style={{ height: "90%", width: "100%", objectFit: "cover" }}
            alt={imageAltText}
          />
        </div>
        <div className="container">
          {projectList.map((project) => (
            <div className="box" key={project.title}>
              <a href={project.url} target="_blank" rel="noopener noreferrer">
                <h3 style={{ flexBasis: "40px" }}>{project.title}</h3>
              </a>
              <p className="small">{project.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
